<template>
  <span>
    <i class="fa fa-edit fa-primary ml-2" @click="onModal()"/>

    <Modal ref="category-update"
           @onClose="onCloseModal"
           :values="modalValues">
      <template slot="body">
        <div class="modal-body">
          <div v-if="spinners.contentIsLoading" class="text-center">
            <b-spinner type="grow" variant="primary"/>
          </div>
          <div v-else>
            <b-row>
              <b-col cols="6">
               <b-form-group>
                  <label>{{ 'title' | translate('global') }}</label>
                  <b-form-input type="text" :placeholder=" 'category_name_placeholder' | translate('global') "
                                :class="{ 'is-invalid' : errorMsg.name }"
                                v-model="category.name"/>
                  <div class="invalid-feedback" v-if="errorMsg.name">{{ errorMsg.name[0] }}</div>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group>
                  <label>{{ 'category_parent' | translate('global') }}</label>
                  <treeselect value-format="object" :disabled="categoryParentDisabled"
                              :class="{ 'treeselect-error' : errorMsg.parent_id }"
                              :placeholder=" 'category_parent_placeholder' | translate('global') "
                              :options="categoriesOptions" v-model="selectedParent"/>
                  <span class="error-text" v-if="errorMsg.parent_id">{{ errorMsg.parent_id[0] }}</span>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group>
                  <label>{{ 'ax_default_expenses_income' | translate('global') }}</label>
                  <treeselect value-format="object"
                              :class="{ 'treeselect-error' : errorMsg.default_expenses_income_classifier_id }"
                              :placeholder=" 'ax_expenses_income_dimension_placeholder' | translate('global') "
                              :options="expensesIncomeOptions"
                              v-model="selectedExpensesIncome"/>
                  <span class="error-text" v-if="errorMsg.default_expenses_income_classifier_id">
                    {{ errorMsg.default_expenses_income_classifier_id[0] }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group>
                  <label>{{ 'ax_default_product' | translate('global') }}</label>
                  <treeselect value-format="object" :default-expand-level="1"
                              :placeholder="'ax_product_placeholder' | translate('global')"
                              :class="{ 'treeselect-error' : errorMsg.default_product_id }"
                              instanceId="loadAxProducts"
                              :load-options="loadOptions" :async="true" :cacheOptions="false"
                              :searchPromptText="'ax_product_autocomplete' | translate('global')"
                              :noResultsText="'no_results_found' | translate('global')"
                              v-model="selectedProduct"/>
                  <span class="error-text" v-if="errorMsg.default_product_id">
                    {{ errorMsg.default_product_id[0] }}
                  </span>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </template>
      <template slot="footer">
        <b-button variant="success" data-dismiss="modal" :disabled="spinners.isSaving" @click='updateCategory()'>
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ 'save' | translate('global') }}
        </b-button>
        <b-button variant="secondary" @click="onCloseModal()" class="ml-2">
          {{ 'cancel' | translate('global') }}
        </b-button>
      </template>
    </Modal>
  </span>
</template>
<script>
import statuses from '@/store/statuses';
import { mapActions, mapGetters } from 'vuex';
import VuexTypes from '@/store/types/index';
import Services from '@/services/index';
import forEach from 'lodash.foreach';
import Modal from '@/views/sharedComponents/Modal';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import TreeselectMixin from '@/mixins/TreeselectMixin';

const ProcurementSchemeTypes = VuexTypes.procurementScheme;
const ProcurementSchemeService = Services.procurementScheme;
export default {
  props: ['id'],
  mixins: [TreeselectMixin],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
        isSaving: false,
      },
      modalValues: {
        id: 'category-update',
        size: 'lg',
        title: this.$t('category_update', 'global'),
      },
      category: {
        name: '',
        parent_id: '',
        default_expenses_income_classifier_id: null,
        default_product_id: null,
      },
      categoryParentDisabled: null,
      selectedParent: null,
      selectedExpensesIncome: null,
      selectedProduct: null,
      expensesIncomeOptions: [],
      categoriesOptions: [{
        id: '',
        label: this.$t('not_have_parent', 'global'),
      }],
      errorMsg: {}
    };
  },
  components: { Modal, Treeselect },
  computed: {
    ...mapGetters('ProcurementScheme', [
      'categoryUpdateData',
      'categoryUpdate'
    ]),
  },
  watch: {
    selectedParent: function () {
      this.category['parent_id'] = this.selectedParent ? this.selectedParent['id'] : null;
    },
    selectedExpensesIncome: function () {
      this.category['default_expenses_income_classifier_id'] = this.selectedExpensesIncome
        ? this.selectedExpensesIncome['id'] : null;
    },
    selectedProduct: function () {
      this.category['default_product_id'] = this.selectedProduct
        ? this.selectedProduct['id'] : null;
    },
    categoryUpdateData: {
      handler: function () {
        if (this.categoryUpdateData.status !== statuses.LOADING) {
          this.fillData();
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
    categoryUpdate: {
      handler: function () {
        if (this.categoryUpdate.status !== statuses.LOADING) {
          this.spinners.isSaving = false;
        }
        if (this.categoryUpdate.status === statuses.LOADED) {
          this.onCloseModal();
        } else if (this.categoryUpdate.status === statuses.ERROR) {
          this.errorMsg = this.categoryUpdate.data.data.errors;
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('ProcurementScheme', [
      ProcurementSchemeTypes.CATEGORY_UPDATE_DATA,
      ProcurementSchemeTypes.CATEGORY_UPDATE,
    ]),
    getData() {
      this.CATEGORY_UPDATE_DATA(this.id);
    },
    fillData() {
      const category = this.categoryUpdateData.data.category;
      this.category.name = category['name'];
      this.category.parent_id = category['parent_id'];
      this.category.default_expenses_income_classifier_id = category['default_expenses_income_classifier_id'];
      this.category.default_product_id = category['default_product_id'];

      const expensesIncomeClassifiers = this.categoryUpdateData.data['expenses_income_classifiers'];

      this.expensesIncomeOptions = this.fillTreeselectDropdown(expensesIncomeClassifiers, 'id', 'name');

      if (category['default_expenses_income_classifier']) {
        this.selectedExpensesIncome = {
          id: category['default_expenses_income_classifier']['id'],
          label: category['default_expenses_income_classifier']['name']
        };
      }
      if (category['default_product']) {
        this.selectedProduct = {
          id: category['default_product']['id'],
          label: category['default_product']['name']
        };
      }

      if (category.parent) {
        this.selectedParent = {
          id: category.parent['id'],
          label: category.parent['name']
        };
      } else {
        this.selectedParent = {
          id: '',
          label: this.$t('not_have_parent', 'global')
        };
      }

      // if category have child`s -> parent change disabled and dropdown not needed
      if (!category.childrens.length) {
        const result = [{
          id: '',
          label: this.$t('not_have_parent', 'global'),
        }];
        this.categoryParentDisabled = false;
        forEach(this.categoryUpdateData.data.categories, (item) => {
          const children = [];
          if (item['childrens']) {
            forEach(item['childrens'], (child) => {
              children.push({
                id: child['id'],
                label: child['name'],
                isDisabled: true
              });
            });
          }
          if (children.length) {
            result.push({
              id: item['id'],
              label: item['name'],
              children: children
            });
          } else {
            result.push({
              id: item['id'],
              label: item['name']
            });
          }
        });
        this.categoriesOptions = result;
      } else {
        this.categoryParentDisabled = true;
      }
    },
    async loadOptions({ action, searchQuery, callback, instanceId }) {
      let options = [];
      const query = searchQuery.trim();
      if (action === 'ASYNC_SEARCH') {
        const valid = this.checkSearchQuery(query);
        if (valid) {
          options = await this[instanceId](query);
        }
      }
      callback(null, options);
    },
    async loadAxProducts(name) {
      const param = name || '';
      const data = await ProcurementSchemeService.productsAXSearch(param);
      const options = [];
      forEach(data.data.data, (item) => {
        options.push({
          id: item['id'],
          label: item['full_name'],
          isDisabled: !item['is_active'],
        });
      });
      return options;
    },
    onModal() {
      this.spinners.contentIsLoading = true;
      this.cleanData();
      this.getData();
      this.showModal();
    },
    onCloseModal() {
      this.closeModal();
      this.cleanData();
    },
    showModal() {
      this.$refs['category-update'].show();
    },
    closeModal() {
      this.$refs['category-update'].hide();
    },
    cleanData() {
      this.category = {
        name: '',
        parent_id: '',
        default_expenses_income_classifier_id: null,
        default_product_id: null,
      };
      this.errorMsg = {};
    },
    updateCategory() {
      this.spinners.isSaving = true;
      let data = this.category;
      if (this.categoryParentDisabled) {
        data = {
          name: this.category['name'],
          default_expenses_income_classifier_id: this.category['default_expenses_income_classifier_id'],
          default_product_id: this.category['default_product_id'],
        };
      }
      this.CATEGORY_UPDATE({
        id: this.id,
        updateData: data
      });
    },
  }
};
</script>
